<template>
    <div>
        <div class="faq-area default-padding bg-gray" style="padding-top: 80px; padding-left: 30%;">
            <div class="container">
                <div class="faq-items">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="faq-content pt-5 pb-5">
                                <div class="services-area bg-gray left-border bottom-less">
                                    <!-- Shape Fixed Rotation -->
                                    <div class="shape-fixed animation-rotation"><img src="assets/img/round-shappe.png" alt="Thumb" /></div>
                                    <div class="container" style="padding: 0px; border-radius: 16px;">
                                        <div class="services-items">
                                            <div class="form-box" style="width: 470px;">
                                                <div class="row">
                                                    <div v-if="seccionRestaurar" class="col-md-12">
                                                        <div v-if="validandoDatos">
                                                            <center>
                                                                <h4>{{ usuarioRespuesta}}</h4>
                                                                <h3>estamos validando sus datos, espere un momento por favor...</h3>
                                                                <span class="spinner-border" 
                                                                    style="height: 2rem; width: 2rem;"
                                                                        role="status">
                                                                </span>
                                                            </center>

                                                        </div>
                                                        <div v-else-if="!tokenActivo || tokenVencido ">
                                                            <center v-show="mostrarMensaje">
                                                                <h4>
                                                                    {{ mensajeRespuesta }} 
                                                                    <br >
                                                                </h4>
                                                            </center>
                                                            
                                                            <span v-if="mostrarSolicitudLink">
                                                                <center>
                                                                    <div class="button">
                                                                        <a href="/restaurarPass" @click.prevent="limpiarDatos()" class="btn-standard btn-restaurar">
                                                                            <span class="textBtn">Iniciar Solicitud aquí</span>
                                                                        </a>
                                                                    </div>
                                                                </center>
                                                            </span>

                                                        </div>
                                                        <div v-else-if="restaurado">
                                                            <center>
                                                                <h4>{{ mensajeRestaurado }}</h4>
                                                                <div class="button">
                                                                    <a href="/restaurarPass" @click.prevent="limpiarDatos()" class="btn-standard btn-restaurar">
                                                                        <span class="textBtn">Finalizar</span>
                                                                    </a>
                                                                </div>
                                                            </center>
                                                        </div>
                                                        <div v-else>
                                                            <h4>Restaurar mi Contraseña</h4>
                                                            <!--<div>{{ usuarioRespuesta }}</div>
                                                            <div>{{ tokenRespuesta }}</div>
                                                            <div>{{ correoRespuesta }}</div>-->
                                                            <p class="textUserName">Tiempo restante: {{ temporizadorTexto }}</p>
                                                            <div class="form-group" style="margin-bottom: 0;">
                                                                <div class="input-group-password">
                                                                    <input 
                                                                        @input="validarPassword"
                                                                        :type="mostrarPassword ? 'text' : 'password'"
                                                                        v-model="password"
                                                                        placeholder="Contraseña" required
                                                                        class="form-control-password"
                                                                        style="width: 75%;"
                                                                        :class="{ error: tieneErrores }" />
                                                                    <span class="textUserName toggle-password fas fa-eye"
                                                                        :class="{ 'fa-eye-slash': !mostrarPassword }" @click="mostrarPassword = !mostrarPassword">
                                                                    </span>
                                                                </div>

                                                                <div class="input-group-password">
                                                                    <input
                                                                        @input="validarPassword"
                                                                        :type="mostrarPassword ? 'text' : 'password'"
                                                                        v-model="confirmarPassword"
                                                                        placeholder="Confirmar Contraseña"
                                                                        class="form-control-password"
                                                                        style="width: 75%;"
                                                                        :class="{ error: tieneErrores }"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <span class="textUserName">La contraseña debe contener: </span>
                                                                <ul class="password-rules">
                                                                    <li v-for="(validacion, index) in validaciones" 
                                                                        :key="index"
                                                                        class="fas"
                                                                        :class="{'fa-minus-circle': !validacion.valido, 'fa-check-circle': validacion.valido}"    
                                                                        :style="{ color: validacion.valido ? '#4caf50' : '#e63946' }">
                                                                        {{ validacion.texto }}
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                            <div class="button align-items-center">
                                                                <a href="#"  class="btn-standard  btn-restaurar" style="border: none;" @click.prevent="restaurar" :disabled="restaurando">
                                                                <i class="fas fa-angle-right" v-show="!restaurando"></i>
                                                                <div class="spinner-border"  v-show="restaurando" style="height: 2rem; width: 2rem;" role="status"></div>
                                                                <span class="textBtn" v-if="restaurando">Restaurando su contraseña </span>
                                                                <span class="textBtn" v-else>Restaurar</span>
                                                            </a>
                                                            </div>
                                                        </div>
                                                        
                                                    </div>
                                                    <div v-if="!seccionRestaurar" class="col-md-12">
                                                        <h4>Solicitud Restaurar mi Contraseña</h4>

                                                        <div class="form-group">
                                                            <label for="inputTextuserName">
                                                                Nombre de Usuario Vapp
                                                                <span class="textUserName">(Ejemplo: usuario@vapp.cl)</span>
                                                            </label>
                                                            <input type="text" id="inputTextuserName" v-model="usuario"
                                                                placeholder="Su nombre de usuario aquí" required
                                                                class="form-control mb-2" />

                                                            <label for="inputMail">
                                                                Correo personal asociado a Vapp
                                                                <span class="textUserName">(Ejemplo: miCorreo@mail.com)</span>
                                                            </label>
                                                            <input type="email" id="inputMail" v-model="correo"
                                                                placeholder="Su correo personal aquí" required
                                                                class="form-control" />
                                                        </div>

                                                        <div class="button">
                                                            <a href="#"  class="btn-standard  btn-restaurar" style="border: none;" @click.prevent="inicioSolicitud" :disabled="iniciandoSolicitud">
                                                                <i class="fas fa-angle-right" v-show="!iniciandoSolicitud"></i>
                                                                <div class="spinner-border"  v-show="iniciandoSolicitud" style="height: 2rem; width: 2rem;" role="status"></div>
                                                                <span class="textBtn" v-if="iniciandoSolicitud">Consultando </span>
                                                                <span class="textBtn" v-else>Solicitar restauración</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>


</template>

<script>

    import axios from "axios"
    import cons from '@/utils/const'
    import { differenceInSeconds, formatDuration, intervalToDuration } from 'date-fns';
    import { es } from 'date-fns/locale';

export default {
    name: "RestaurarContrasena",
    data() {
        return {
            
            seccionRestaurar: false,

            //solicitud
            usuario: "",
            correo: "",
            iniciandoSolicitud: false,
            //fin solicitud

            validandoDatos: false,
            tokenActivo: false,
            tokenVencido: false,
            idIntervaloValidarToken: null,

            temporizadorTexto: "",
            idIntervaloTemporizador: null,

            usuarioRespuesta: null,
            correoRespuesta: null,
            nombreUsuario: null,
            tokenRespuesta: null,

            mostrarMensaje: false,
            mensajeRespuesta: null,
            mostrarSolicitudLink: false,

            password: '',
            confirmarPassword: '',
            mostrarPassword: false,
            tieneErrores: true,

            restaurando: false,
            restaurado: false,
            mensajeRestaurado: "",

            validaciones: {
                nombreApellido: {
                    texto: "No puede contener su nombre o apellido",
                    valido: false,
                    regExpres: () => new RegExp(`${this.nombreUsuario}`, 'i')
                },
                largoMinimo: {
                    texto: "Debe tener al menos 10 caracteres",
                    valido: false,
                    regExpres: /.{10,}/
                },
                mayuscula: {
                    texto: "Debe contener al menos una letra mayúscula",
                    valido: false,
                    regExpres: /[A-Z]/
                },
                minuscula: {
                    texto: "Debe contener al menos una letra minúscula",
                    valido: false,
                    regExpres: /[a-z]/
                },
                numero: {
                    texto: "Debe contener al menos un número",
                    valido: false,
                    regExpres: /\d/
                },
                especial: {
                    texto: "Debe contener al menos un carácter especial ($,*#,etc.)",
                    valido: false,
                    regExpres: /[!@#$%^&*(),.?":{}|<>_\-+=[\]\\\/]/
                },
                usuarioIncluido: {
                    texto: "No puede contener su nombre de usuario",
                    valido: false,
                    regExpres: () => new RegExp(this.usuarioRespuesta, 'i')
                },
                coinciden: {
                    texto: "Las contraseñas deben coincidir",
                    valido: false,
                    regExpres: null 
                }
                }
        };
    },
    beforeDestroy(){
        localStorage.removeItem('vencimientoToken');
        clearInterval(this.idIntervaloValidarToken)
        clearInterval(this.idIntervaloTemporizador);
    },
    mounted() {
        if(this.$route.query.hasOwnProperty('token')){
            this.tokenRespuesta = this.$route.query.token;
            this.usuarioRespuesta = this.$route.query.hasOwnProperty('userName') ? this.$route.query.userName : null;
            if(this.usuarioRespuesta == null){
                this.mostrarNotificaciones(3, "No se ha recibido el nombre de usuario asociado al token", 20);
            }else{
                this.seccionRestaurar = true;
                this.activarToken()
            }
        }
    },

    methods: {
        limpiarDatos: function(){
            this.usuario = "";
            this.correo = "";
            this.password = "";
            this.confirmarPassword = "";
            this.mostrarPassword = false;
            this.tieneErrores = true;
            this.tokenActivo = false;
            this.tokenVencido = false;
            this.usuarioRespuesta = null;
            this.correoRespuesta = null;
            this.tokenRespuesta = null;
            this.nombreUsuario = null;
            this.seccionRestaurar = false;

            for (const key in this.validaciones) {
                const regla = this.validaciones[key];
                regla.valido = false;
            }
            this.$router.push('restaurarPass')

        },
        inicioSolicitud: function () {
            this.iniciandoSolicitud = true;
            var url = `${cons.protocol}://${cons.ipServer}/resetear_psw_usuario_vapp`
            
            this.mostrarNotificaciones(4, "Iniciando proceso de restauración de contraseña...");

            axios({
                method: "POST",
                url: url,
                data: {
                    "info": {
                        "userName": this.usuario,
                        "mailUser": this.correo
                    }
                },
            })
            .then((result) => {
                this.mostrarNotificaciones(1, result.data.mensajeGeneral, 50)
            },
            (error) => {

                this.mostrarNotificaciones(2, error.response.data.mensajeGeneral, 50)
            })
            .finally(() => {
                this.iniciandoSolicitud = false;
            });
        },
        restaurar: function () {
            this.restaurando = true;
            const reglasFallidas = Object.values(this.validaciones)
                .filter(regla => !regla.valido)
                .map(regla => `${regla.texto}`);

            if (reglasFallidas.length === 0) {

                let url = `${cons.protocol}://${cons.ipServer}/cambio_psw_usuario_vapp`;
                axios({
                    method: "POST",
                    url: url,
                    data: {
                        "info": {
                            "token": this.tokenRespuesta,
                            "nuevaPsw": this.password,
                            "userName": this.usuarioRespuesta
                        }
                    },
                })
                .then((result) => {
                    this.mensajeRestaurado = result.data.mensajeGeneral;
                    this.mostrarNotificaciones(1, this.mensajeRestaurado, 10);
                    this.restaurado = true;
                     if (this.idIntervaloTemporizador) {
                        clearInterval(this.idIntervaloTemporizador);
                    }
                    if (this.idIntervaloValidarToken) {
                        clearInterval(this.idIntervaloValidarToken);
                    }
                },
                (error) => {
                    this.mostrarNotificaciones(3, error.response.data.mensajeGeneral, 10);
                })
                .finally(() => {
                    this.restaurando = false;
                });
                
            } else {

                let limite = 3;
                reglasFallidas.forEach(regla => {
                    const mensaje = `La regla siguiente no cumple: ${regla}`;
                    if (reglasFallidas.indexOf(regla) < limite)
                        this.mostrarNotificaciones(2, mensaje, 10);
                    if(reglasFallidas.indexOf(regla) === limite - 1) {
                        this.mostrarNotificaciones(2, "Existen más reglas que no se cumplen, revisa las reglas de contraseña", 10);
                    }
                });
                
                this.restaurando = false;
                
            }
        },

        validarPassword: function() {
            const pwd = this.password;
            const confirmPwd = this.confirmarPassword;

            for (const key in this.validaciones) {
                const regla = this.validaciones[key];

                if (key === 'coinciden') {
                    regla.valido = pwd === confirmPwd && pwd.length > 0;
                }

                else if (typeof regla.regExpres === 'function') {
                    const regex = regla.regExpres();
                    regla.valido = !regex.test(pwd); 
                }
                else {
                    regla.valido = regla.regExpres.test(pwd);
                }
            }
        },
        consultarToken: function() {
            let url = `${cons.protocol}://${cons.ipServer}/validar_token_psw`
            axios({
                method: "POST",
                url: url,
                data: {
                    "info": {
                        "token": this.tokenRespuesta,
                        "userName": this.usuarioRespuesta
                    }
                },
            })
            .then((result) => {

                const almacenado = JSON.parse(localStorage.getItem('vencimientoToken'));
                if (almacenado && String(almacenado.horaVencimientoToken) !== String(result.data.horaExpiracionToken)) {
                    localStorage.setItem('vencimientoToken', JSON.stringify({
                        horaVencimientoToken: result.data.horaExpiracionToken,
                        token: this.tokenRespuesta
                    }));

                    this.iniciarTemporizador(result.data.horaExpiracionToken);
                }

            },
            (error) => {
                this.procesarRespuesta(error.response.data, 2);
            })
            
        },
        activarToken: function() {
            this.validandoDatos = true;
            let url = `${cons.protocol}://${cons.ipServer}/activar_tkn`
            
            axios({
                method: "POST",
                url: url,
                data: {
                    "info": {
                        "token": this.tokenRespuesta,
                        "userName": this.usuarioRespuesta
                    }
                },
            })
            .then((result) => {
                this.procesarRespuesta(result.data, 1);
                if(!this.tokenVencido){
                    const vencimientoToken = JSON.parse(localStorage.getItem('vencimientoToken')) || null;
                    
                    if (!vencimientoToken || String(vencimientoToken.horaVencimientoToken) !== String(result.data.horaExpiracionToken)) {
                        localStorage.setItem('vencimientoToken', JSON.stringify({
                            horaVencimientoToken: result.data.horaExpiracionToken,
                            token: this.tokenRespuesta
                        }));
                    }
                } else{
                    localStorage.removeItem('vencimientoToken');
                }

                this.iniciarTemporizador(result.data.horaExpiracionToken);


            },
            (error) => {
                
                this.procesarRespuesta(error.response.data, 2);
            })
            .finally(() => {
                this.validandoDatos = false;
            });

        },
        procesarRespuesta: function(data, tipoNotificacion) {
            this.mostrarMensaje = data.mostrarMensaje;
            this.mensajeRespuesta = data.mensajeGeneral;
            this.mostrarSolicitudLink = data.mostrarSolicitudLink;
            this.tokenActivo = data.estadoTkn;

            if (data.hasOwnProperty('tokenVencido')) {
                this.tokenVencido = data.tokenVencido;
            }

            this.mostrarNotificaciones(tipoNotificacion, data.mensajeGeneral, 10);
        },
        iniciarTemporizador(horaExpiracion) {
            if (this.idIntervaloTemporizador) {
                clearInterval(this.idIntervaloTemporizador);
            }
            if (this.idIntervaloValidarToken) {
                clearInterval(this.idIntervaloValidarToken);
            }

            const expira = new Date(horaExpiracion);

            this.idIntervaloTemporizador = setInterval(() => {
                const ahora = new Date();
                const segundosRestantes = differenceInSeconds(expira, ahora);

                if (segundosRestantes <= 0) {
                    clearInterval(this.idIntervaloTemporizador);
                    clearInterval(this.idIntervaloValidarToken);
                    this.temporizadorTexto = "Token expirado";
                    setTimeout(() => {
                        this.consultarToken();
                    }, 2000);
                    
                
                    return;
                }

                const duracion = intervalToDuration({ start: ahora, end: expira });
                this.temporizadorTexto = formatDuration(duracion, { format: ['hours', 'minutes', 'seconds'], locale: es });
            }, 1000);

            this.idIntervaloValidarToken = setInterval(() => {
                this.consultarToken();
            }, 120000);
        },

    }
};
</script>

<style scoped>

/* ===== FORM BOX CON TRANSICIÓN DEGRADADO ===== */
.form-box {
  position: relative;
  background-color: white;
  padding: 30px;
  border-radius: 16px;
  color: #333;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: color 0.3s ease;
}

/* Gradiente que sube al hacer hover */
.form-box::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0%;
  background: linear-gradient(to top, #3e1f61, #3a8dde);
  border-radius: inherit;
  z-index: 0;
  transition: height 0.5s ease;
}

.form-box:hover::before {
  height: 100%;
}

/* Asegura que el contenido esté encima del gradiente */
.form-box > * {
  position: relative;
  z-index: 1;
}

/* ===== ESTILOS DE LABEL Y TEXTO DE EJEMPLO ===== */

/* Texto del label (negro a blanco) */
.form-group label {
  display: block;
  font-weight: 600;
  margin-bottom: 3px;
  color: #000;
  transition: color 0.3s ease;
}

/* Texto de ejemplo (rojo a negro) */
.textUserName {
  font-size: 12px;
  color: #d12b2b;
  margin-left: 4px;
  transition: color 0.3s ease;
}

/* Colores al hacer hover en .form-box */
.form-box:hover .form-group label {
  color: #000;
}

.form-box:hover .textUserName {
  color: white;
}


/* Inputs */
/* ===== INPUTS ===== */
.form-control {
  background-color: #fff;
  color: #333;
  border: none;
  padding: 14px 16px;
  border-radius: 12px;
  font-size: 15px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  margin-bottom: 15px;
  transition: box-shadow 0.3s;
}

.form-control:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(100, 149, 237, 0.4);
}


/* Estado base con gradiente */
.btn-restaurar a.btn-restaurar {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 10px !important;
  padding: 12px 24px !important;
  border-radius: 50px !important;
  font-weight: bold !important;
  font-size: 16px !important;
  color: black !important;
  background: linear-gradient(to right, #6e184c, #380d48) !important; /* gradiente base */
  text-decoration: none !important;
  transition: background 0.3s ease, transform 0.2s ease !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3) !important;
}

/* Hover: color sólido #5c1c46 */
.btn-restaurar a.btn-restaurar:hover {
  background: #5c1c46 !important;
  transform: translateY(-2px) !important;
  color: white !important;
  border: #000;
}
.form-box:hover a.btn-restaurar{
    border: 1px solid #e7e7e7 !important;
}

.textBtn:hover{
  color: white !important;
}
.form-box:hover .textBtn{
    color: white !important;
}


/* Spinner opcional */
.spinner-border {
  width: 1rem;
  height: 1rem;
  border-width: 2px;
  color: #000;
}
.form-box:hover .spinner-border {
  color: white;
}

.password-rules {
  padding-left: 0;
  list-style: none;
  font-size: 11px;
}

.password-rules li {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
}

.password-rules li::before {
  display: inline-block;
  margin-right: 3px;
}

.form-control-password {
  background-color: #fff;
  color: #333;
  border: none;
  padding: 14px 16px;
  border-radius: 12px;
  font-size: 15px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  margin-bottom: 15px;
  transition: box-shadow 0.3s;
}

.form-control-password:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(100, 149, 237, 0.4);
}

.input-password {
  width: 100%;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid #ccc;
  font-size: 16px;
  transition: border-color 0.3s;
  background-color: #fff;
  color: #333;
}

.input-password:focus {
  border-color: #3a8dde;
  outline: none;
}

/* Input con error */
.form-control-password.error {
  border-color: #e63946 !important;
}

/* Icono ojo a la derecha */
.input-group-password {
  position: relative;
  display: flex;
  align-items: center;
}

.input-group-password .toggle-password {
  position: absolute;
  right: 16px;
  cursor: pointer;
  color: #666;
  font-size: 18px;
  z-index: 2;
}


</style>
